//Url Base
export const baseUrl = document.getElementById('baseFullPath').getAttribute('href');

//Controllers Web API
const articuloController = 'API/Articulo';
const bitacoraController = 'API/Bitacora';
const callCenterMonitor = 'API/CallCenterMonitor';
const facPG2Controller = 'API/FACPG2';
const loginController = 'API/Login';
const lotesController = 'API/Lotes';
const Mantenimientos = 'API/Mantenimientos';
const menuController = 'API/Menu';
const monitorSucursal = 'API/MonitorSucursal';
const ordenPagoController = 'API/OrdenPago';
const parametroController = 'API/Parametro';
const subOrdenDetalleController = 'API/SubOrdenDetalle';
const sucursalController = 'API/Sucursal';
const procesosController = 'API/Procesos'
const Reporte = 'Reporte';

//Routes
export const ArticuloRutas = {
    Validar_Articulo_Despacho: `${baseUrl}${articuloController}/Validar_Articulo_Despacho`
};

export const BitacoraRutas = {
    Registrar_Bitacora_Credomatic: `${baseUrl}${bitacoraController}/Registrar_Bitacora_Credomatic`,
    Actualizar_Bitacora_Credomatic: `${baseUrl}${bitacoraController}/Actualizar_Bitacora_Credomatic`
};

export const CallCenterMonitorRutas = {
    Obtener_Articulos_Orden: `${baseUrl}${callCenterMonitor}/Obtener_Articulos_Orden`,
    Obtener_Conteo_Ordenes: `${baseUrl}${callCenterMonitor}/Obtener_Conteo_Ordenes`,
    Obtener_Detalles_Orden: `${baseUrl}${callCenterMonitor}/Obtener_Detalles_Orden`,
    Obtener_Estatus: `${baseUrl}${callCenterMonitor}/Obtener_Estatus`,
    Obtener_Ordenes: `${baseUrl}${callCenterMonitor}/Obtener_Ordenes`,
    Obtener_Tiempos_Ordenes: `${baseUrl}${callCenterMonitor}/Obtener_Tiempos_Ordenes`
};

export const FACPG2Rutas = {
    Reversal: `${baseUrl}${facPG2Controller}/Anular`
};

export const LoginRutas = {
    Cambiar_Contrasena: `${baseUrl}${loginController}/Cambiar_Contrasena`,
    Cambiar_Pin: `${baseUrl}${loginController}/Cambiar_Pin`,
    Login: `${baseUrl}${loginController}/Login`,
    Login_Token: `${baseUrl}${loginController}/Login_Token`
};

export const LotesRutas = {
    Agregar_Inventario_Detalles_Lote: `${baseUrl}${lotesController}/Agregar_Inventario_Detalles_Lote`,
    Agregar_SubOrden_Detalles_Lote: `${baseUrl}${lotesController}/Agregar_SubOrden_Detalles_Lote`,
    Eliminar_SubOrden_Detalles_Lote_Por_Articulo: `${baseUrl}${lotesController}/Eliminar_SubOrden_Detalles_Lote_Por_Articulo`,
    Obtener_Conexion_Lote: `${baseUrl}${lotesController}/Obtener_Conexion_Lote`,
    Obtener_SubOrden_Detalles_Lote: `${baseUrl}${lotesController}/Obtener_SubOrden_Detalles_Lote`
};

export const MantenimientosRutas = {
    Call_Center_Detalle: `${baseUrl}${Mantenimientos}/Call_Center_Detalle`,
    Call_Center_Agregar: `${baseUrl}${Mantenimientos}/Call_Center_Agregar`,
    Call_Center_Modificar: `${baseUrl}${Mantenimientos}/Call_Center_Modificar`,
    Call_Center_Eliminar: `${baseUrl}${Mantenimientos}/Call_Center_Eliminar`,
    Obtener_Cadenas_Empresa: `${baseUrl}${Mantenimientos}/Obtener_Cadenas_Empresa`,
    ParametroCallCenter_Detalle: `${baseUrl}${Mantenimientos}/ParametroCallCenter_Detalle`,
    ParametroCallCenter_Agregar: `${baseUrl}${Mantenimientos}/ParametroCallCenter_Agregar`,
    ParametroCallCenter_Modificar: `${baseUrl}${Mantenimientos}/ParametroCallCenter_Modificar`,
    ParametroCallCenter_Eliminar: `${baseUrl}${Mantenimientos}/ParametroCallCenter_Eliminar`,
    Servicio_Lista: `${baseUrl}${Mantenimientos}/Servicio_Lista`,
    Pais_Lista: `${baseUrl}${Mantenimientos}/Pais_Lista`,
    Tipo_Movimiento_Inv_Lista: `${baseUrl}${Mantenimientos}/Tipo_Movimiento_Inv_Lista`,
    Cliente_Detalle: `${baseUrl}${Mantenimientos}/Cliente_Detalle`,
    Cliente_Lista: `${baseUrl}${Mantenimientos}/Cliente_Lista`,
    Zona_Lista: `${baseUrl}${Mantenimientos}/Zona_Lista`,
    Zona_Eliminar: `${baseUrl}${Mantenimientos}/Zona_Eliminar`,
    Zona_Modificar: `${baseUrl}${Mantenimientos}/Zona_Modificar`,
    Zona_Agregar: `${baseUrl}${Mantenimientos}/Zona_Agregar`,
    Zona_Detalle: `${baseUrl}${Mantenimientos}/Zona_Detalle`,
    SucursalesZona_Lista: `${baseUrl}${Mantenimientos}/SucursalesZona_Lista`,
    SucursalZona_Obtener_Sucursales_CallCenter: `${baseUrl}${Mantenimientos}/SucursalZona_Obtener_Sucursales_CallCenter`,
    Obtener_Sucursales_Lista: `${baseUrl}${Mantenimientos}/Obtener_Sucursales_Lista`,
    ListaSucursalesPorZonaGuardar: `${baseUrl}${Mantenimientos}/ListaSucursalesPorZonaGuardar`,
    Colores_Lista: `${baseUrl}${Mantenimientos}/Colores_Lista`,
    Color_Detalle: `${baseUrl}${Mantenimientos}/Color_Detalle`,
    Color_Eliminar: `${baseUrl}${Mantenimientos}/Color_Eliminar`,
    Color_Agregar: `${baseUrl}${Mantenimientos}/Color_Agregar`,
    Color_Modificar: `${baseUrl}${Mantenimientos}/Color_Modificar`,
    Repartidores_Lista: `${baseUrl}${Mantenimientos}/Repartidores_Lista`,
    Repartidor_Detalle: `${baseUrl}${Mantenimientos}/Repartidor_Detalle`,
    Repartidor_Eliminar: `${baseUrl}${Mantenimientos}/Repartidor_Eliminar`,
    Repartidor_Agregar: `${baseUrl}${Mantenimientos}/Repartidor_Agregar`,
    Repartidor_Modificar: `${baseUrl}${Mantenimientos}/Repartidor_Modificar`,
    Tiempos_Lista: `${baseUrl}${Mantenimientos}/Tiempos_Lista`,
    Tiempo_Modificar: `${baseUrl}${Mantenimientos}/Tiempo_Modificar`,
};

export const MenuRutas = {
    Obtener_Menu: `${baseUrl}${menuController}/Obtener_Menu`,
    Obtener_MenuOpciones: `${baseUrl}${menuController}/Obtener_MenuOpciones`,
    Seg_Usuario_Validar_Opcion: `${baseUrl}${menuController}/Seg_Usuario_Validar_Opcion`
};

export const MonitorSucursalRutas = {
    Eliminar_Orden_Completo_Orden: `${baseUrl}${monitorSucursal}/Eliminar_Orden_Completo_Orden`,
    Exp_Despachar_Orden_Ecommerce: `${baseUrl}${monitorSucursal}/Exp_Despachar_Orden_Ecommerce`,
    Exp_Orden_Encabezado_Par_Imprime: `${baseUrl}${monitorSucursal}/Exp_Orden_Encabezado_Par_Imprime`,
    ExpSuborden_Encabezado_Par_Listar: `${baseUrl}${monitorSucursal}/ExpSuborden_Encabezado_Par_Listar`,
    Listar_Ordenes_A_Pantalla: `${baseUrl}${monitorSucursal}/Listar_Ordenes_A_Pantalla`,
    Movimiento_Inventario: `${baseUrl}${monitorSucursal}/Movimiento_Inventario`,
    Obtener_Autorizador_Tarjeta: `${baseUrl}${monitorSucursal}/Obtener_Autorizador_Tarjeta`,
    Ordenes_Muestra_Despacho_RO: `${baseUrl}${monitorSucursal}/Ordenes_Muestra_Despacho_RO`,
    SubOrdenes_Muestra_Despacho_RO: `${baseUrl}${monitorSucursal}/SubOrdenes_Muestra_Despacho_RO`,
    Verifica_Movimientos_Aplicados_Orden: `${baseUrl}${monitorSucursal}/Verifica_Movimientos_Aplicados_Orden`,
};

export const OrdenPagoRutas = {
    Obtener_Pago_Referencias_Tarjetas: `${baseUrl}${ordenPagoController}/Obtener_Pago_Referencias_Tarjetas`
};

export const ParametroRutas = {
    Obtener_CallCenter_Empresa: `${baseUrl}${parametroController}/Obtener_CallCenter_Empresa`,
    Obtener_Empresas: `${baseUrl}${parametroController}/Obtener_Empresas`,
    Get_Description_Report: `${baseUrl}${parametroController}/Get_Description_Report`,
    ObtieneParametroSucursal: `${baseUrl}${parametroController}/ObtieneParametroSucursal`,
    Obtener_Simbolo_Moneda: `${baseUrl}${parametroController}/Obtener_Simbolo_Moneda`,
    Obtener_Estado_Active_Directory: `${baseUrl}${parametroController}/Obtener_Estado_Active_Directory`
};

export const ProcesosRutas = {
    AnalisisTiempoOrden_Listar: `${baseUrl}${procesosController}/AnalisisTiempoOrden_Listar`,
    Control_Monitoreo_Detalle: `${baseUrl}${procesosController}/Control_Monitoreo_Detalle`,   
    Exp_Validar_Despacho_Orden_Ecommerce: `${baseUrl}${procesosController}/Exp_Validar_Despacho_Orden_Ecommerce`,
    Exp_Orden_Encabezado_Par_Detalle: `${baseUrl}${procesosController}/Exp_Orden_Encabezado_Par_Detalle`,
    Exp_Orden_Encabezado_Detalle: `${baseUrl}${procesosController}/Exp_Orden_Encabezado_Detalle`,
    Exp_Orden_Tipo_Pagos: `${baseUrl}${procesosController}/Exp_Orden_Tipo_Pagos`,
    Obtener_Formas_Pago_Orden: `${baseUrl}${procesosController}/Obtener_Formas_Pago_Orden`,
   
    Liquidar_Orden_Express: `${baseUrl}${procesosController}/Liquidar_Orden_Express`,
    Listar_Ordenes_A_Pantalla_Gen: `${baseUrl}${procesosController}/Listar_Ordenes_A_Pantalla_Gen`,
    Listar_ParametrosGenerales: `${baseUrl}${procesosController}/Listar_ParametrosGenerales`,
    Listar_ParametrosCadena: `${baseUrl}${procesosController}/Listar_ParametrosCadena`,     
    ExpSuborden_Encabezado_Listar_Gen: `${baseUrl}${procesosController}/ExpSuborden_Encabezado_Listar_Gen`,
    Obtener_Repartidores: `${baseUrl}${procesosController}/Obtener_Repartidores`,
    Obtener_Ordenes_Sin_Asignar: `${baseUrl}${procesosController}/Obtener_Ordenes_Sin_Asignar`,
    Obtener_Configuraciones: `${baseUrl}${procesosController}/Obtener_Configuraciones`,
    AR_Asignar_Repartidor: `${baseUrl}${procesosController}/Asignar_Orden_Repartidor`,
    AR_Desasignar_Repartidor: `${baseUrl}${procesosController}/AR_Desasignar_Repartidor`,
    AR_Obtener_Productos_Orden: `${baseUrl}${procesosController}/Obtener_Productos_Orden`,
    AR_Obtener_Productos_Ordenes: `${baseUrl}${procesosController}/Obtener_Productos_Ordenes`,
    AR_Repartidor_En_Ruta: `${baseUrl}${procesosController}/Repartidor_En_Ruta`,   
    Picking_Obtener_Opciones_Menu: `${baseUrl}${procesosController}/Picking_Obtener_Opciones_Menu`,
    Picking_Traslado_Fue_Aplicado: `${baseUrl}${procesosController}/Picking_Traslado_Fue_Aplicado`,
    Picking_Suborden_Requiere_Traslado: `${baseUrl}${procesosController}/Picking_Suborden_Requiere_Traslado`,
    Picking_Orden_Requiere_Traslado: `${baseUrl}${procesosController}/Picking_Orden_Requiere_Traslado`,
    Picking_Obtener_Intervalo_Recoger_Tienda: `${baseUrl}${procesosController}/Picking_Obtener_Intervalo_Recoger_Tienda`,
    Picking_Suborden_Esta_Pendiente: `${baseUrl}${procesosController}/Picking_Suborden_Esta_Pendiente`,
    Picking_Orden_Esta_Pendiente: `${baseUrl}${procesosController}/Picking_Orden_Esta_Pendiente`,
    Picking_Suborden_Esta_Auditada: `${baseUrl}${procesosController}/Picking_Suborden_Esta_Auditada`,
    Picking_Obtener_Sucursales_Orden_Seg_Usuario: `${baseUrl}${procesosController}/Picking_Obtener_Sucursales_Orden_Seg_Usuario`,
    Picking_Obtener_Traslado: `${baseUrl}${procesosController}/Picking_Obtener_Traslado`,
    Picking_Aplicar_Traslado: `${baseUrl}${procesosController}/Picking_Aplicar_Traslado`,
    Picking_Aplicar_Picking: `${baseUrl}${procesosController}/Picking_Aplicar_Picking`,
    Picking_Auditar_Producto_Orden: `${baseUrl}${procesosController}/Picking_Auditar_Producto_Orden`,
    Picking_Obtener_Estatus_Producto_Orden: `${baseUrl}${procesosController}/Picking_Obtener_Estatus_Producto_Orden`,
    Picking_Obtener_Productos_Orden: `${baseUrl}${procesosController}/Picking_Obtener_Productos_Orden`,
    Picking_Obtener_Sucursales_X_Usuario: `${baseUrl}${procesosController}/Picking_Obtener_Sucursales_X_Usuario`,
    Picking_Obtener_Ordenes: `${baseUrl}${procesosController}/Picking_Obtener_Ordenes`,
    Guardar_Entrega_Repartidores: `${baseUrl}${procesosController}/Guardar_Entrega_Repartidores`,
    Eliminar_Orden_Entrega_Ruta: `${baseUrl}${procesosController}/Eliminar_Orden_Entrega_Ruta`
};

export const ReporteRutas = {
    SetParametrosReporte: `${baseUrl}${Reporte}/SetParametrosReporte`,
};

export const SubOrdenDetalleRutas = {
    Modificar_Detalle_Orden_Articulo_Validado: `${baseUrl}${subOrdenDetalleController}/Modificar_Detalle_Orden_Articulo_Validado`
};

export const SucursalRutas = {
    Obtener_Sucursales_CallCenter: `${baseUrl}${sucursalController}/Obtener_Sucursales_CallCenter`,
    Obtener_Sucursales_Monitoreo: `${baseUrl}${sucursalController}/Obtener_Sucursales_Monitoreo`
};

//Url Routes for Components
export const SiteRutas = {
    AtencionRecepcionista: '/AtencionRecepcionista',
    Base: '/',
    CallCenter: '/CallCenter',
    CallCenterMantenimiento: '/CallCenterMantenimiento',
    CambiarContrasena: '/CambiarContrasena',
    CambiarPin: '/CambiarPin',
    ClientePedidoRealizado: '/ClientePedidoRealizado',
    Color: '/Color',
    CompraColonia: '/CompraColonia',
    CompraServicioDomicilio: '/CompraServicioDomicilio',
    ConsultaRepartidores: '/ConsultaRepartidores',
    Historial: '/Historial',
    Home: '/Home',
    LiquidarOrden: '/LiquidarOrden',
    Login: '/Login',
    MonitorCallCenterDetalle: '/MonitorCallCenterDetalle',
    MonitorCallCenter: '/MonitorCallCenter',
    MonitorSucursales: '/MonitorSucursales',
    Parametros: '/Parametros',
    PedidoHora: '/PedidoHora',
    PedidoPresupuesto: '/PedidoPresupuesto',
    PedidoZona: '/PedidoZona',
    Picking: '/Picking',
    Repartidor: '/Repartidor',
    RepartidorMantenimiento: '/RepartidorMantenimiento',
    RepartidorHora: '/RepartidorHora',
    Sucursales: '/Sucursales',
    TiempoHora: '/TiempoHora',
    Tiempos: '/Tiempos',
    TiemposReclamo: '/TiemposReclamo',
    TomaOrden: '/TomaOrden',
    VentasCallCenter: '/VentasCallCenter',
    Zonas: '/Zonas',
    ZonasMantenimiento: '/ZonasMantenimiento',
    Reporte: `/reporte`,
};

export const ImagenesRutas = {
    Logo_LD_Blanco: `${baseUrl}Content/Images/ld-blanco.png`,
    Logo_LD: `${baseUrl}Content/Images/logo-ld.png`,
    Fondo_Login: `${baseUrl}Content/Images/login-bg-min.jpg`,
    Ping: `${baseUrl}Content/Images/map_marker.png`,
    PingSucursal: `${baseUrl}Content/Images/map_marker_sucursal.png`,
    ArtDefault: `${baseUrl}Content/Images/default.png`
};

//Request Header
export const GetHeaderRequest = pToken => {
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${pToken}`
    }
};

export const GetHeaderRequestFormData = pToken => {
    return {
        'Authorization': `Bearer ${pToken}`
    }
};

//Response Body
export const GetResponseBody = pResponse => {
    const contentType = pResponse.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
        return pResponse.json();
    } else {
        switch (pResponse.status) {
            case 401:
                return { Exitoso: false, Mensaje: 'No tiene permisos para acceder a este método.', CodigoError: 2 };
            case 500:
                return { Exitoso: false, Mensaje: 'Ocurrió un error en el servidor.', CodigoError: 999 };
            default:
                return { Exitoso: false, Mensaje: 'Ocurrió un error realizando la acción.', CodigoError: 999 };
        }
    }
};